import { useParams, useLocation, Navigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { LEGAL_PAGES } from "../lib/legalContent";

const LegalPage = () => {
  const params = useParams();
  const location = useLocation();
  // Derive slug from either /:slug URL param OR from pathname like /privacy, /terms, etc.
  const slug = params.slug || location.pathname.replace(/^\//, "");
  const page = LEGAL_PAGES[slug];

  if (!page) return <Navigate to="/" replace />;

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#C89B3C] hover:text-slate-900 text-sm font-medium mb-8 transition-colors"
        >
          <ArrowLeft size={16} /> Back to Home
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="h-[3px] w-14 bg-[#C89B3C] mb-6" />
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-slate-500 mb-3 block">
            {page.eyebrow}
          </span>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#0B2343] leading-tight mb-4">
            {page.title}
          </h1>
          <p className="text-sm text-slate-500 mb-8">Last updated {page.lastUpdated}</p>

          <p className="text-lg text-slate-700 leading-relaxed mb-10">{page.intro}</p>

          <div className="space-y-8">
            {page.sections.map((s, idx) => (
              <section key={idx}>
                <h2 className="font-serif text-xl md:text-2xl font-bold text-slate-900 mb-3 border-b border-slate-200 pb-2">
                  {s.h}
                </h2>
                <p className="text-slate-700 leading-relaxed whitespace-pre-line">{s.body}</p>
              </section>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalPage;
